import {Pipe, PipeTransform} from '@angular/core';
import {CustomTimeValue} from "@model";

@Pipe({
  name: 'formatTime'
})
export class FormatTimePipe implements PipeTransform {

  transform(value?: number | CustomTimeValue | string): string | undefined {
    if (value) {
      if (typeof value === 'number' || typeof value === 'string') {
        return this.transformSeconds(+value);
      } else {
        return this.transformCustomTimeValue(value);
      }
    } else {
      return undefined;
    }
  }

  private transformSeconds(value: number): string | undefined {
    if (!Number.isFinite(value)) {
      return undefined;
    } else {
      let hours: number = Math.floor(value / 3600);
      let minutes: number = Math.floor((value % 3600) / 60);
      let seconds: number = Math.floor(value % 60);
      return [hours, minutes, seconds]
        .map((val: number) => this.padZero(val))
        .join(':');
    }
  }

  private transformCustomTimeValue(value: CustomTimeValue): string | undefined {
    return value.hours || value.minutes || value.seconds ? [value.hours, value.minutes, value.seconds]
      .map(val => this.padZero(val))
      .join(':') : undefined;
  }

  private padZero(val: number | undefined): string {
    return val ? val < 10 ? `0${val}` : `${val}` : `00`;
  }

}
